module.exports = __webpack_public_path__ + "static/media/99gal32.f7694242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal32.jpg
// module id = 407
// module chunks = 0